import { render, staticRenderFns } from "./StatisticWidget.vue?vue&type=template&id=1f8c69dc&scoped=true&"
import script from "./StatisticWidget.vue?vue&type=script&lang=js&"
export * from "./StatisticWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c69dc",
  null
  
)

export default component.exports